var render = function render(_c,_vm){return _c('div',{staticClass:"Column",class:[_vm.$options.cols(_vm.props), _vm.data.class, _vm.data.staticClass],style:(_vm.props.grow && { flexGrow: _vm.props.grow })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }